export default __webpack_public_path__ + "static/media/image-new-password-inbox.033a8ea9.svg";